import { ReferenceManyField, TextField } from 'react-admin';

import {
  GetInstrumentCutoffDatesQuery,
  GetInstrumentCutoffDatesResponseOne,
  getInstrumentCutoffDatesSortColumns,
} from '@Common/types/bo/instruments';

import { DatagridTyped, EmptyScreen, Pagination, ShowSection } from '@sh4res/bo-common/components';
import { IdField, UTCDateField } from '@sh4res/bo-common/fields';
import { EmptyFolderSvg } from '@sh4res/bo-common/graphics';
import { ColumnList, RaSort } from '@sh4res/bo-common/utils';

const NoCutoffDates = () => (
  <EmptyScreen
    label="resources.bo_common.instruments.cutoff_dates.empty"
    svg={<EmptyFolderSvg />}
  />
);

const defaultSort: RaSort<GetInstrumentCutoffDatesQuery> = { field: 'cutoff_date', order: 'ASC' };

const displayedColumns: (keyof GetInstrumentCutoffDatesResponseOne)[] = ['id', 'cutoff_date'];

const columns: ColumnList<GetInstrumentCutoffDatesResponseOne> = {
  // eslint-disable-next-line @sh4res/jsx-id-field-for-resources -- No show page for cutoff dates
  id: <TextField data-testid="BoExternalInstrumentCutoffDatesList_IdField" />,
  instrument_id: (
    <IdField
      reference="instruments"
      data-testid="BoExternalInstrumentCutoffDatesList_InstrumentIdField"
    />
  ),
  cutoff_date: (
    <UTCDateField
      label="resources.bo_common.instruments.cutoff_dates.labels.cutoff_date"
      data-testid="BoExternalInstrumentCutoffDatesList_CutoffDateField"
    />
  ),
};

export const InstrumentCutoffDatesSection = () => (
  <ShowSection label="resources.bo_common.instruments.cutoff_dates.title">
    <ReferenceManyField
      label="resources.bo_common.instruments.cutoff_dates.title"
      reference="instruments/cutoff_dates"
      source="id"
      target="instrument_id"
      sort={defaultSort}
      pagination={<Pagination limit={<></>} handleFloatingButton={true} />}
      data-testid="BoExternalInstrumentCutoffDatesList_List">
      <DatagridTyped<GetInstrumentCutoffDatesResponseOne>
        sortableColumns={getInstrumentCutoffDatesSortColumns}
        columnRegistry={columns}
        displayedColumns={displayedColumns}
        bulkActionButtons={false}
        empty={<NoCutoffDates />}
        sx={{ maxHeight: 'none', overflowY: 'visible' }}
      />
    </ReferenceManyField>
  </ShowSection>
);
